import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { LoadingPage, NotFound } from "../components";
import { HomePage, ServicePage, TransactionPage } from "../pages";
import { AuthProvider } from "../provider";

const Nav = () => (
  <Suspense fallback={<LoadingPage />}>
    <AuthProvider>
      <Routes>
        <Route path="/:corporateName" element={<HomePage />} />
        <Route path="/:corporateName/:id" element={<ServicePage />} />
        <Route
          path="/:corporateName/:id/transaction/:transactionId"
          element={<TransactionPage />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  </Suspense>
);

export default Nav;
